// extracted by mini-css-extract-plugin
export default {"root":"ListShift_root__oHg8K","header":"ListShift_header__fQVCt","actions":"ListShift_actions__f2fc1"};